import React from 'react';
import NotifCard from '@/domains/traffic-monitoring/components/NotifCard/NotifCard';
import Header from '@/shared/components/layout/Header/Header';

// import { showToast } from '@/shared/utils/showToast';

const notifications = [
  {
    group: 'Yesterday',
    items: [
      {
        icon: 'success',
        title: 'Successfully Completed Report',
        desc: 'The report has been successfully marked as completed',
        dateTime: 'Just Now',
        reportId: '#PSC3315-9D47B2E8C4F1',
      },
      {
        icon: 'info',
        title: 'Successfully Completed Report',
        desc: 'The report has been successfully marked as completed',
        dateTime: '2m',
        reportId: '#PSC3315-9D47B2E8C4F1',
      },
      {
        icon: 'reject',
        title: 'Successfully Completed Report',
        desc: 'The report has been successfully marked as completed',
        dateTime: '2m',
        reportId: '#PSC3315-9D47B2E8C4F1',
      },
      {
        icon: 'update',
        title: 'Successfully Completed Report',
        desc: 'The report has been successfully marked as completed',
        dateTime: '2m',
        reportId: '#PSC3315-9D47B2E8C4F1',
      },
    ],
  },
  {
    group: 'Today',
    items: [
      {
        icon: 'reject',
        title: 'Successfully Completed Report',
        desc: 'The report has been successfully marked as completed',
        dateTime: '2m',
        reportId: '#PSC3315-9D47B2E8C4F1',
      },
      {
        icon: 'update',
        title: 'Successfully Completed Report',
        desc: 'The report has been successfully marked as completed',
        dateTime: '2m',
        reportId: '#PSC3315-9D47B2E8C4F1',
      },
    ],
  },
] as const;

const NotificationDashboard = () => {
  return (
    <section className="_cctvDashboard bg-db-wrap flex flex-col gap-[12px] w-full h-screen overflow-hidden">
      <Header />
      <div className="p-3 w-full h-[calc(95vh-15px)] grid grid-cols-1 gap-3 overflow-hidden ">
        <div className="p-6 w-full flex flex-col gap-3 overflow-auto h-full border gap-3 rounded-[12px] bg-db-card bg-db-border">
          <div className="flex flex-col gap-3">
            <span className="title1bold">Notifications</span>
            <span className="title2">
              Stay informed with the latest system updates, incident alerts, assignments, and
              important notifications in one place.
            </span>
          </div>

          <div className="flex h-full w-full flex-col gap-3 overflow-auto">
            {notifications.map((group) => (
              <div key={group.group} className="flex flex-col gap-3">
                <span className="mt-6 uppercase title1 text-db-text-grey">{group.group}</span>

                {group.items.map((item, index) => (
                  <NotifCard
                    key={`${group.group}-${index}`}
                    icon={item.icon}
                    title={item.title}
                    desc={item.desc}
                    dateTime={item.dateTime}
                    reportId={item.reportId}
                  />
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NotificationDashboard;
